import React from 'react';
import StatusBadge from 'SharedComponent/StatusBadge';
import { ReactComponent as CheckCircleIcon } from '../../assets/icons/badge-check-circle-icon.svg';
import { ReactComponent as NoEntryIcon } from '../../assets/icons/badge-no-entry-icon.svg';
import { TextConstants } from 'constants/TextConstants';

const POD_UPLOADED_BADGE_CONFIG: Record<
  'true' | 'false',
  { icon: React.ComponentType<any>; label: string; variant: 'success' | 'danger' }
> = {
  true: { icon: CheckCircleIcon, label: TextConstants.POD_UPLOADED, variant: 'success' },
  false: { icon: NoEntryIcon, label: TextConstants.POD_NOT_UPLOADED, variant: 'danger' },
};

interface PodUploadedBadgeProps {
  isPodUploaded?: boolean | null;
}

const PodUploadedBadge: React.FC<PodUploadedBadgeProps> = ({ isPodUploaded }) => {
  const badge = isPodUploaded !== null && isPodUploaded !== undefined && POD_UPLOADED_BADGE_CONFIG[String(isPodUploaded) as 'true' | 'false'];

  if (!badge) {
    return null;
  }

  return <StatusBadge icon={badge.icon} label={badge.label} variant={badge.variant} />;
};

export default PodUploadedBadge;
